import React from 'react'
import { useSelector } from 'react-redux'
import Grid from '@mui/material/Grid'
import Button from 'components/landing-page/Button'
import { Auth } from 'aws-amplify'

const Dashboard = () => {
  const { user } = useSelector(state => state.auth)

  const logout = async () => {
    await Auth.signOut()
    window.location.reload()
  }

  return (
    <Grid sx={{ height: '100%' }} container justifyContent="center" alignItems="center" flexDirection="column">
      <div>
        <div>User:</div>
        <div>{user?.attributes?.email}</div>
        <div>is Authenticated</div>
      </div>
      <div>
        <Button onClick={logout}>Logout</Button>
      </div>
    </Grid>
  )
}

Dashboard.propTypes = {}

Dashboard.defaultProps = {}

export default Dashboard
